// extracted by mini-css-extract-plugin
module.exports = {"Trainings":"Trainings_Trainings__2zCuu","TrainingWrap":"Trainings_TrainingWrap__1HXBE"};